import * as tslib_1 from "tslib";
import { observable } from 'mobx';
var Message = /** @class */ (function () {
    function Message(dto) {
        Object.assign(this, dto);
    }
    tslib_1.__decorate([
        observable
    ], Message.prototype, "isReaded", void 0);
    return Message;
}());
export default Message;



//////////////////
// WEBPACK FOOTER
// ./src/models/Message.ts
// module id = 199
// module chunks = 0